import Api from './Api'

export default {
  objekt (post, page) {
    return Api().post('/search/objekt.json',
      post,
      { params: { page: page || 1 } }
    )
  },
  objektExport (post) {
    return Api().post('/search/objekt.json',
      post,
      { params: { export: 1 } }
    )
  },
  kunde (post, page) {
    return Api().post('/search/kunde.json',
      post,
      { params: { page: page || 1 } }
    )
  },
  kunstner (post, page, limit) {
    return Api().post('/search/kunstner.json',
      post,
      { params: { page: page || 1, limit: limit || 200 } }
    )
  },
  faktura (post, page) {
    return Api().post('/search/faktura.json',
      post,
      { params: { page: page || 1 } }
    )
  },
  kontrakt (post, page) {
    return Api().post('/search/kontrakt.json',
      post,
      { params: { page: page || 1 } }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/SearchService.js